/* The Other Side — landing behaviour: VSL sound, smooth anchors, sticky bar, one-click checkout with order bump. */
(function () {
  if (window.__tosLanding) return; window.__tosLanding = true;

  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    // VSL: autoplay muted, one tap to hear Jo from the top
    document.querySelectorAll('.tos .vsl').forEach(function (box) {
      var v = box.querySelector('video'), b = box.querySelector('.unmute');
      if (!v || !b) return;
      v.muted = true; v.playsInline = true;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
      b.addEventListener('click', function () {
        v.muted = false; v.currentTime = 0; v.controls = true; v.play(); b.hidden = true;
      });
    });

    // smooth scroll for in-page CTAs
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a || !a.closest('.tos')) return;
      var t = document.querySelector(a.getAttribute('href'));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });

    // sticky CTA: visible once the hero has scrolled away, hidden while the offer is on screen
    var bar = document.querySelector('.tos-sticky');
    var hero = document.querySelector('.tos-hero');
    var offer = document.querySelector('.tos-offer');
    if (bar && 'IntersectionObserver' in window) {
      var heroOut = false, offerIn = false;
      var sync = function () { bar.classList.toggle('on', heroOut && !offerIn); };
      if (hero) new IntersectionObserver(function (en) { heroOut = !en[0].isIntersecting; sync(); }).observe(hero);
      if (offer) new IntersectionObserver(function (en) { offerIn = en[0].isIntersecting; sync(); }, { threshold: 0.15 }).observe(offer);
    }


    // launch window: live countdown to a real deadline; everything tied to it disappears at zero
    var dl = document.querySelector('[data-tos-deadline]');
    if (dl) {
      var end = Date.parse(dl.getAttribute('data-tos-deadline'));
      var kick = document.querySelector('[data-tos-sticky-kicker]');
      var kickDefault = kick ? kick.textContent : '';
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var tick = function () {
        var ms = end - Date.now();
        if (isNaN(end) || ms <= 0) {
          document.querySelectorAll('.tos-launch').forEach(function (x) { x.remove(); });
          if (kick) kick.textContent = kickDefault;
          clearInterval(iv); return;
        }
        var d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, m = Math.floor(ms / 6e4) % 60, s = Math.floor(ms / 1e3) % 60;
        var txt = (d ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
        document.querySelectorAll('[data-tos-cd]').forEach(function (el) {
          if (el.dataset.tosCd === 'grid') {
            var set = function (u, v) { var b = el.querySelector('[data-u=' + u + ']'); if (b) b.textContent = v; };
            set('d', d); set('h', pad(h)); set('m', pad(m)); set('s', pad(s));
          } else el.textContent = txt;
        });
        if (kick) kick.textContent = (kick.dataset.prefix || 'Launch price ends in') + ' ' + txt;
      };
      var iv = setInterval(tick, 1000); tick();
    }

    // "start tonight": the visitor's own clock, nothing invented
    document.querySelectorAll('[data-tos-tonight]').forEach(function (el) {
      var n = new Date(), hr = n.getHours();
      var t = n.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
      el.textContent = (hr >= 17 || hr < 2)
        ? "It's " + t + " where you are. The download is instant — page one can be tonight."
        : "It's " + t + " where you are. Download it now, open page one tonight.";
      el.hidden = false;
    });

    // buy forms: optional cart clear, add tier + bump, straight to checkout
    document.querySelectorAll('form.tos-buy').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return; // plain form post fallback
        e.preventDefault();
        var btn = form.querySelector('button[type=submit]');
        var err = form.closest('.tos-offer') ? form.closest('.tos-offer').querySelector('.err') : null;
        var sec = form.closest('.tos-offer');
        var items = [{ id: Number(form.querySelector('input[name=id]').value), quantity: 1 }];
        var bump = sec ? sec.querySelector('.tos-bump-input') : null;
        if (bump && bump.checked && form.dataset.includesBump !== 'true' && bump.value && bump.value !== form.querySelector('input[name=id]').value) {
          items.push({ id: Number(bump.value), quantity: 1 });
        }
        var go = form.dataset.return || '/checkout';
        if (btn) { btn.disabled = true; btn.dataset.label = btn.innerHTML; btn.innerHTML = 'One moment…'; }
        var clear = form.dataset.clear === 'true' ? fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } }) : Promise.resolve();
        clear.then(function () {
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) });
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); });
          window.location.href = go;
        }).catch(function (x) {
          if (err) err.textContent = x.message + ' — please try again.';
          if (btn) { btn.disabled = false; btn.innerHTML = btn.dataset.label; }
        });
      });
    });
  });
})();
